import React, { useState } from 'react';
import { Dialog } from '../../atoms/dialog';
import SuspendPayPalForm from './SuspendPayPalForm';
import UpdatePayPalDetailsForm from './UpdatePayPalDetailsForm';
import { PayPalCharityDetailsODataModel } from '../../../types/templates/PayPalCharityDetailsODataModel';
import { ManagePayPalDialogState } from './ManagePayPalView';

export enum ManagePayPalDialogTypes {
    Closed,
    Edit,
    Suspend,
};

export interface ManagePayPalUpdateForm {
    selectedCharity: PayPalCharityDetailsODataModel;
    onSubmit: (charityToUpdate: PayPalCharityDetailsODataModel) => void;
    isLoading: boolean;
}

export interface ManagePayPalDialogProps {
    dialog: ManagePayPalDialogState;
    closeDialog: (withAction: boolean) => void;
}

const ManagePayPalDialog = function ManagePayPalDialog({
    dialog,
    closeDialog,
}: ManagePayPalDialogProps) {
    const [isLoading, setIsLoading] = useState(false);
    const { type, selectedCharity } = dialog;
    const selectedCharityName = `${selectedCharity?.CharityName ?? ''} `;

    const updateCharity = async (charityToUpdate: PayPalCharityDetailsODataModel) => {
        setIsLoading(true);

        try {
            const res = await fetch('/Admin/PayPal/Charity/Save', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(charityToUpdate),
            });

            if (!res.ok) {
                return;
            }

            closeDialog(true);
        } finally {
            setIsLoading(false);
        }
    };

    const getDialogDetails = () => {
        if (!selectedCharity) {
            return undefined;
        }

        if (type === ManagePayPalDialogTypes.Edit) {
            return {
                title: `Edit ${selectedCharityName}PayPal Details`,
                content: (
                    <UpdatePayPalDetailsForm
                        selectedCharity={selectedCharity}
                        onSubmit={updateCharity}
                        isLoading={isLoading}
                    />
                ),
            };
        }

        if (type === ManagePayPalDialogTypes.Suspend) {
            return {
                title:
                    `Are you sure you want to ${selectedCharity.IsSuspended ? 'unsuspend' : 'suspend'} ${selectedCharityName} PayPal givings?`,
                content: (
                    <SuspendPayPalForm
                        selectedCharity={selectedCharity}
                        onSubmit={updateCharity}
                        isLoading={isLoading}
                    />
                ),
            };
        }

        return undefined;
    };

    const dialogDetails = getDialogDetails();

    if (!dialogDetails) {
        return null;
    }

    const { title, content } = dialogDetails;

    return (
        <Dialog
            title={title}
            isOpen={type !== null}
            contentSlot={content}
            onClose={() => closeDialog(false)}
        />
    );
};

export default ManagePayPalDialog;
